import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const notSelectedCategoryApi = createAsyncThunk(
    'auth/non-selected-category',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.categoriesAction("select_category", 0), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const notSelectedCategorySlice = createSlice({
    name: 'non-selected-category',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(notSelectedCategoryApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(notSelectedCategoryApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(notSelectedCategoryApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const notSelectedCategoryReducer = notSelectedCategorySlice.reducer